import React from "react";
import CrmLinks from "../../components/Crm/CrmLinks";
import CrmGraphSegment from "../../components/Crm/CrmGraph";

const CrmGraph = () => {
  return (
    <>
      <CrmLinks />
      <CrmGraphSegment />
    </>
  );
};

export default CrmGraph;
